import { render, staticRenderFns } from "./declareview.vue?vue&type=template&id=bd0814ca&scoped=true"
import script from "./declareview.vue?vue&type=script&lang=js"
export * from "./declareview.vue?vue&type=script&lang=js"
import style0 from "./declareview.vue?vue&type=style&index=0&id=bd0814ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0814ca",
  null
  
)

export default component.exports